module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productDetailContent"
  }, [_c('div', {
    staticClass: "page-item"
  }, [_c('div', {
    staticClass: "content productshow"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "infobox"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "mainimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.big,
      "alt": _vm.product.name
    }
  }), _vm._v(" "), (_vm.defaultImg == _vm.big && _vm.productVideo != '' && _vm.productVideo != null) ? _c('div', {
    staticClass: "playbtn",
    on: {
      "click": function($event) {
        return _vm.showVideo(_vm.productVideo, _vm.product.name + '视频')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "imglist"
  }, [_c('ul', _vm._l((_vm.small), function(item, i) {
    return (i < 6) ? _c('li', {
      key: i,
      class: _vm.big == item ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.setBig(i)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": _vm.product.name
      }
    })]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "imgbottom"
  }, [_c('a', [(!_vm.product.isCollect) ? _c('i', {
    staticClass: "icon icon-start",
    on: {
      "click": function($event) {
        return _vm._collect(_vm.product.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.isCollect) ? _c('i', {
    staticClass: "icon icon-start1",
    on: {
      "click": function($event) {
        return _vm._removeCollect(_vm.product.id)
      }
    }
  }) : _vm._e(), _vm._v("\r\n                                    收藏商品(" + _vm._s(this.product.collectNum) + "人气)\r\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "pDetail t"
  }, [_vm._v("\r\n                                " + _vm._s(_vm.product.name) + "\r\n                            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.discountAmount > 0) ? _c('div', {
    staticClass: "pDetail price"
  }, [(_vm.sellPrice != _vm.settlementPrice) ? _c('div', {
    staticClass: "price1"
  }, [_vm._v("优惠前："), _c('span', [_vm._v("￥" + _vm._s(_vm.sellPrice.toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "price3"
  }, [_vm._v("￥" + _vm._s(_vm.discountAmount.toFixed(2)))]), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price2"
  }, [_vm._v("券后："), _c('span', [_vm._v("￥" + _vm._s(_vm.settlementPrice.toFixed(2)))])])]) : _c('div', {
    staticClass: "pDetail price"
  }, [(_vm.sellPrice != _vm.settlementPrice) ? _c('div', {
    staticClass: "price1"
  }, [_vm._v("原价："), _c('span', [_vm._v("￥" + _vm._s(_vm.sellPrice.toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price2"
  }, [_vm._v("售价："), _c('span', [_vm._v("￥" + _vm._s(_vm.settlementPrice.toFixed(2)))])])]), _vm._v(" "), _vm._l((_vm.frontendPropertyInfo), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "pDetail sku"
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v("\r\n                                  " + _vm._s(item.name) + "：\r\n                                ")]), _vm._v(" "), _c('ul', _vm._l((item.propertyDetails), function(p, j) {
      return _c('li', {
        key: j,
        class: (p.disable == true ? 'disableSpec ' : '') + (p.current == true ? 'on' : ''),
        on: {
          "click": function($event) {
            p.disable == true ? _vm.selAttr1() : _vm.selAttr(i, j)
          }
        }
      }, [_vm._v("\r\n                                        " + _vm._s(p.name) + "\r\n                                    ")])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "pDetail num"
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("\r\n                                    数量：\r\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "numbox"
  }, [_c('span', {
    on: {
      "click": _vm.reduceNum
    }
  }, [_vm._v("\r\n                                        -\r\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num),
      expression: "num"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.num)
    },
    on: {
      "change": _vm.changeNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.num = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.addNum
    }
  }, [_vm._v("\r\n                                        +\r\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "t"
  }, [_vm._v("\r\n                                  库存剩余(" + _vm._s(_vm.stockNum) + ")\r\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "pDetail btns",
    style: (_vm.product.saleStatus != 0 ? 'display:none;' : '')
  }, [_c('a', {
    staticClass: "buy",
    on: {
      "click": function($event) {
        return _vm.checkout(_vm.product.id)
      }
    }
  }, [_vm._v("立即购买")]), _vm._v(" "), _c('a', {
    staticClass: "addcar",
    on: {
      "click": function($event) {
        return _vm.addCart(_vm.product.id, _vm.settlementPrice, _vm.product.name, _vm.product.defaultImage)
      }
    }
  }, [_vm._v("加入购物车")])])], 2)]), _vm._v(" "), (_vm.product.labels && _vm.product.labels.length > 0) ? _c('div', {
    staticClass: "labelbox"
  }, [_vm._l((_vm.product.labels), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "productLabel"
    }, [_c('div', {
      staticClass: "labelIcon"
    }, [(item.labelIcon) ? _c('img', {
      attrs: {
        "src": item.labelIcon
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "labelName",
      attrs: {
        "title": item.description
      }
    }, [_vm._v(_vm._s(item.labelName)), _c('span', [_vm._v(_vm._s(item.description))])]), _vm._v(" "), ((index % 2 == 0 && (_vm.product.labels.length - index) > 2) || index % 2 == 1 && (_vm.product.labels.length - index) >= 2) ? _c('hr', {
      class: (index) % 2 == 0 ? 'horizontal-left' : 'horizontal-right'
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "desbox"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', {
    class: _vm.describeType == 0 ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.setDescribe(0)
      }
    }
  }, [_vm._v("商品详情")]), _vm._v(" "), _c('li', {
    class: _vm.describeType == 1 ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.setDescribe(1)
      }
    }
  }, [_vm._v("累积评价"), (_vm.evaluateTotal > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.evaluateTotal) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "navbox"
  }, [(_vm.describeType == 0) ? _c('div', {
    staticClass: "navbox-content ql-editor",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.productMsg)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.describeType == 1) ? _c('div', {
    staticClass: "navbox-content"
  }, [_vm._l((_vm.evaluates), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "evaluateHead"
    }, [_c('div', {
      staticClass: "evaluateAvatar"
    }, [(item.avatar) ? _c('img', {
      staticClass: "photo",
      attrs: {
        "src": item.avatar
      }
    }) : _c('img', {
      staticClass: "photo",
      attrs: {
        "src": "https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png"
      }
    }), _vm._v(" "), (item.sex == 0 || item.sex == false) ? _c('img', {
      staticClass: "sex",
      attrs: {
        "title": "女",
        "src": "https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png"
      }
    }) : _c('img', {
      staticClass: "sex",
      attrs: {
        "title": "男",
        "src": "https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "evaluateMember"
    }, [_c('span', [_vm._v(_vm._s(item.memberName))]), _c('br'), _vm._v("     \r\n                                    " + _vm._s(item.intervalTime) + " "), (!item.specName && item.specName != '0') ? _c('span', [_vm._v(_vm._s(item.specName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "evaluateContent"
    }, [_vm._v(" " + _vm._s(item.evaluateContent))]), _vm._v(" "), (item.evaluatePictures && item.evaluatePictures.length > 0) ? _c('div', {
      staticClass: "evaluateImage"
    }, _vm._l((item.evaluatePictures), function(item1, index1) {
      return _c('img', {
        key: index1,
        attrs: {
          "src": item1
        },
        on: {
          "click": function($event) {
            return _vm.showImage(item1, '评价图片')
          }
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.addends && item.addends.length > 0) ? _c('div', {
      staticClass: "evaluateAddend"
    }, _vm._l((item.addends), function(item1, index1) {
      return _c('div', {
        key: index1
      }, [_c('div', {
        staticClass: "evaluateReplyContent"
      }, [_c('span', [_vm._v(_vm._s(item1.intervalTime) + "追评：")]), _vm._v(_vm._s(item1.evaluateContent))]), _vm._v(" "), (item1.evaluatePictures && item1.evaluatePictures.length > 0) ? _c('div', {
        staticClass: "evaluateImage"
      }, _vm._l((item1.evaluatePictures), function(item2, index2) {
        return _c('img', {
          key: index2,
          attrs: {
            "src": item2
          },
          on: {
            "click": function($event) {
              return _vm.showImage(item2, '追评图片')
            }
          }
        })
      }), 0) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item.replys && item.replys.length > 0) ? _c('div', {
      staticClass: "evaluateReply"
    }, _vm._l((item.replys), function(item1, index1) {
      return _c('div', {
        key: index1
      }, [_c('div', {
        staticClass: "evaluateReplyContent"
      }, [_c('span', [_vm._v(_vm._s(item1.intervalTime) + "回复：")]), _vm._v(_vm._s(item1.evaluateContent))]), _vm._v(" "), (item1.evaluatePictures && item1.evaluatePictures.length > 0) ? _c('div', {
        staticClass: "evaluateImage"
      }, _vm._l((item1.evaluatePictures), function(item2, index2) {
        return _c('img', {
          key: index2,
          attrs: {
            "src": item2
          },
          on: {
            "click": function($event) {
              return _vm.showImage(item2, '回复图片')
            }
          }
        })
      }), 0) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "evaluateTail"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "evaluatePage"
  }, [(!_vm.noResult && !_vm.error) ? _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage3,
      "layout": "prev, pager, next, jumper",
      "total": _vm.evaluateTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.currentPage3 = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage3 = $event
      }
    }
  }) : _vm._e()], 1)], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [(_vm.supplier) ? _c('div', {
    staticClass: "supplier",
    staticStyle: {
      "min-height": "228px",
      "height": "auto !important"
    }
  }, [(_vm.supplier.supplierLogo) ? _c('img', {
    attrs: {
      "src": _vm.supplier.supplierLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "supplierName"
  }, [_vm._v(_vm._s(_vm.supplier.supplierName))]), _vm._v(" "), (_vm.supplier.labels) ? _c('div', {
    staticClass: "supplierLabel"
  }, _vm._l((_vm.supplier.labels), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "padding": "2px 5px 2px 5px",
        "margin-left": "5px",
        "margin-top": "2px",
        "height": "auto !important",
        "background-color": "#f0f9eb",
        "border-color": "#e1f3d8",
        "color": "#67c23a"
      }
    }, [_vm._v(_vm._s(item.labelName))])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "supplierBtn",
    on: {
      "click": _vm.toSupplier
    }
  }, [_vm._m(2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("商城热卖")]), _vm._v(" "), _c('ul', _vm._l((_vm.productList), function(item, i) {
    return _c('li', {
      key: i
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "price1"
    }, [_vm._v("\r\n                                        ￥" + _vm._s(item.settlementPrice.toFixed(2)) + "\r\n                                    ")]), _vm._v(" "), _c('span', {
      staticClass: "price2"
    }, [_vm._v("\r\n                                        ￥" + _vm._s(item.sellPrice.toFixed(2)) + "\r\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "ptitle",
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_vm._v("\r\n                                    " + _vm._s(item.name) + "\r\n                                ")])])
  }), 0)])])]), _vm._v(" "), _c('videoShow', {
    ref: "videoShow"
  }), _vm._v(" "), _c('imageShow', {
    ref: "imageShow"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pDetail tags",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', [_vm._v("经典")]), _vm._v(" "), _c('span', [_vm._v("潮流")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "price4"
  }, [_vm._v("军人优待券"), _c('span', [_vm._v("即时可用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "http://file-sz.fjjykj.com.cn/Supply/se919e00d1de3930d887d67eebd282e15.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s3ddb52f022fb50f6fe82592174971b0d.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20442a0f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/goods/goodsDetails.vue
// module id = 746
// module chunks = 2